export const DEFAULT_FX_RATES = [
    { currency: "CAD", actualFxVsCad: 1.0, bufferedFxVsCad: 1.0 },
    { currency: "USD", actualFxVsCad: 0.74, bufferedFxVsCad: 0.762 },
    { currency: "EUR", actualFxVsCad: 0.68, bufferedFxVsCad: 0.7 },
    { currency: "AED", actualFxVsCad: 2.72, bufferedFxVsCad: 2.802 },
  ];

export const DEFAULT_ROYALTY_RULES = [
    {
      royaltyRegion: "Regular",
      royaltyRule: "Default Wholesale",
      royaltyPercent: 5.0,
    },
    { royaltyRegion: "Regular", royaltyRule: "Default Web", royaltyPercent: 15.0 },
    {
      royaltyRegion: "MENA",
      royaltyRule: "Chef Deema MENA Wholesale",
      royaltyPercent: 7.5,
    },
    { royaltyRegion: "Regular", royaltyRule: "Chef Deema Web", royaltyPercent: 15.0 },
    {
      royaltyRegion: "Regular",
      royaltyRule: "Co-Branded Wholesale",
      royaltyPercent: 10.0,
    },
    {
      royaltyRegion: "Regular",
      royaltyRule: "Co-Branded Web",
      royaltyPercent: 20.0,
    },
  ];


 export const royaltyRegions = ["Regular", "MENA"];
  
export  const royaltyRulesList = [
    "Default Wholesale",
    "Default Web",
    "Chef Deema MENA Whc",
    "Chef Deema Web",
    "Co-Branded Wholesale",
    "Co-Branded Web",
  ];

export const CATEGORY_RULE_DEFAULT_ROWS = [
  { category: "A Spice Affair UN CA", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "A Spice Affair UN EU", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "A Spice Affair UN MENA", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "A Spice Affair UN MX", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "A Spice Affair UN US", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "ASA 3-Packs UN", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "ASA Bottles: 14oz UN", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "ASA Bottles: 29oz UN", signaturePremiumPerUnit: 0.75, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "ASA Grinders Set", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "ASA Grinders UN", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "ASA: Large Pouch", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.4 },
  { category: "ASA: Large Pouch Display", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.4 },
  { category: "ASA: Sauces, Gravies & Coating Pouches", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.4 },
  { category: "Co-Branded: Chef Amine Signature", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Deema Pouches", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.1, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Deema Shakers", signaturePremiumPerUnit: 0.75, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Deema Signature", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Island Gurl Pouches", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Island Gurl Shakers", signaturePremiumPerUnit: 0.75, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.35 },
  { category: "Co-Branded: Chef Island Gurl Signature", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.35 },
  { category: "NutriVilla Bags 50g UN", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.33 },
  { category: "Passion d\u00e9pices UN", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0.4 },
  { category: "Spice Age Beverage Mixes", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.3 },
  { category: "Spice Age GF Bake Mixes", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.3 },
  { category: "Spice Age Seasonings Small Pouch", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0.3 },
  { category: "Spice Blends VRAC", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.6 },
  { category: "Spices Bulk 1 KG", signaturePremiumPerUnit: 1, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0.5 },
  { category: "Spices Bulk 2.5 KG", signaturePremiumPerUnit: 0.75, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0.475 },
  { category: "Spices Bulk 5 KG", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0.45 },
  { category: "Spices Bulk 10 KG", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0.425 },
  { category: "Spices Bulk 25 KG (MASTER)", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.4 },
  { category: "Spices Bulk VRAC", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.5 },
  { category: "Spice Blends Custom VRAC", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.6 },
  { category: "Spices Custom 5 KG", signaturePremiumPerUnit: 1, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0.55 },
  { category: "Spices Custom 25 KG (MASTER)", signaturePremiumPerUnit: 0.5, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.5 },
  { category: "Spices Custom VRAC", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.65 },
  { category: "ASA Variety Packs 12-PK", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "ASA Variety Packs 4-PK", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "ASA Variety Packs 6-PK", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "Gift Sets", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "Swag", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0.3 },
  { category: "Displays", signaturePremiumPerUnit: 0, allergenPremiumPerUnit: 0, minRetailSrpMargin: 0 },
  { category: "Private Label: Baker Large Shaker", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.25, minRetailSrpMargin: 0 },
  { category: "Private Label: Baker PL-6", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0 },
  { category: "Private Label: Youngevity Pouches", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0 },
  { category: "Private Label: WATC Pouches", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0 },
  { category: "Private Label: Bulk", signaturePremiumPerUnit: 0.75, allergenPremiumPerUnit: 0.5, minRetailSrpMargin: 0 },
  { category: "Private Label: Retail Packaging", signaturePremiumPerUnit: 0.25, allergenPremiumPerUnit: 0.15, minRetailSrpMargin: 0 },
];
